import React from 'react'

enum ChatState {
    Enabled,
    Disabled,
    Loading,
}

interface ReturnProps {
    isLoading: boolean
    isDisabled: boolean
    isEnabled: boolean
}

export const useChatbot = (): ReturnProps => {
    const [widgetStatus, setWidgetStatus] = React.useState(ChatState.Loading)
    const widgetStatusRef = React.useRef(widgetStatus)

    React.useEffect(() => {
        widgetStatusRef.current = widgetStatus
    }, [widgetStatus])

    React.useEffect(() => {
        if (widgetStatusRef.current === ChatState.Enabled) {
            return
        }

        const onConversationsAPIReady = () => {
            const status = window.HubSpotConversations.widget.status()

            if (status.loaded) {
                setWidgetStatus(ChatState.Enabled)
            }

            window.HubSpotConversations.on('widgetLoaded', () => {
                setWidgetStatus(ChatState.Enabled)
            })
        }

        //  If external API methods are already available, use them.
        if (window.HubSpotConversations) {
            onConversationsAPIReady()
        } else {
            // These callbacks will be called once the external API has been initialized.
            window.hsConversationsOnReady = [onConversationsAPIReady]
        }

        // In case the widget doesn't load after 5s, we hide the chat slice
        const widgetLoadTimeout = setTimeout(() => {
            if (widgetStatusRef.current === ChatState.Loading) {
                setWidgetStatus(ChatState.Disabled)
            }
        }, 5000)

        return () => {
            window.HubSpotConversations?.off('widgetLoaded', () => {})
            clearTimeout(widgetLoadTimeout)
        }
    }, [])

    return {
        isLoading: widgetStatus === ChatState.Loading,
        isDisabled: widgetStatus === ChatState.Disabled,
        isEnabled: widgetStatus === ChatState.Enabled,
    }
}

export const openChatbot = () => {
    window.HubSpotConversations?.widget?.open?.()
}

export const refreshChatbot = () => {
    window.HubSpotConversations?.widget?.refresh?.()
}
